<div data-cy="upload_page">
  <section>
    <h2>{{ "START_TITLE" | translate }}</h2>
  </section>
  <section class="layout-content mt">
    <p>{{ "START_DESCRIPTION" | translate }}</p>
  </section>

  <div class="well responsive-layout mt">
    <div style="flex:2">
      <section>
        <strong>{{ "PHOTO_CONSIDERATION" | translate }}</strong>
        <ul>
          <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_1' | translate"></span></li>
          <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_2' | translate"></span></li>
          <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_3' | translate"></span></li>
          <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_4' | translate"></span></li>
          <li><i class="fa fa-circle"></i><span [innerHTML]="'PHOTO_CONSIDERATION_5' | translate"></span></li>
        </ul>
      </section>
      <section>
        <strong>{{ "ASSESSMENT_CONSIDERATION" | translate }}</strong>
        <ul>
          <li><i class="fa fa-circle"></i>{{ 'ASSESSMENT_CONSIDERATION_1'  | translate }}</li>
          <li><i class="fa fa-circle"></i>{{ 'ASSESSMENT_CONSIDERATION_2'  | translate }}</li>
        </ul>
      </section>
    </div>
    <div class="example-photo-wrapper" style="flex:1;">
      <img style="max-height: 420px;" src="{{assetsUrl}}/example-480x420.png" class="example-photo"
           alt="Exempel foto på skada">
      <p style="line-height: 100%"><small>{{ "PHOTO_EXAMPLE" | translate }}</small></p>
    </div>
  </div>
  <section class="layout-content" style="margin-top: 25px;">
    <take-picture [isDisabled]="isInProgress" (photoChange)="onPhotoChange($event)"></take-picture>
  </section>

  <section style="margin-top: 25px;" [innerHTML]="'BOOKING_CREATE_NO_PHOTO_TO_UPLOAD' | translate">

  </section>
  <section class="layout-content mt">
    <button type="button" class="btn btn-secondary btn-lg" [ngClass]="{'btn-wide' :false}" [disabled]="false"
            (click)="onWebbookingNavigate()">{{ 'BOOKING_CREATE_WORKSHOP' | translate }}
    </button>
  </section>
</div>
